
import React, { useState } from 'react';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import SendIcon from '@material-ui/icons/Send';

import { tariffs } from '../../billing/timesheets/BillingTariff';
import { Paper, Grid, Button } from '@material-ui/core';

const TariffPicker = ({ onContinue }) => {
    const [value, setValue] = useState('tier1');

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    return (
        <Paper style={{ padding: '1rem' }}>
            <Grid container direction="column" spacing={1}>
                <Grid item>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Please choose a default tariff</FormLabel>
                        <RadioGroup aria-label="tariff" name="tariff" value={value} onChange={handleChange}>
                            {
                                Array.from(tariffs.keys()).map(k => {
                                    const { code, description } = tariffs.get(k);
                                    return <FormControlLabel key={`tariff-${k}`} value={code} control={<Radio />} label={description} />
                                })
                            }
                        </RadioGroup>
                    </FormControl>
                </Grid> 
                <Grid item>
                    <Button variant="contained" color="secondary" onClick={() => onContinue(value)} endIcon={<SendIcon />}>
                      Continue to quote
                    </Button>
                </Grid>
            </Grid>
            
        </Paper>
    );
}

export default TariffPicker;